import { useEffect, useState } from 'react';
import type Uppy from '@uppy/core';

import StatusBarPlugin from '@uppy/status-bar';

import Box from '@mui/material/Box';

const STATUS_BAR_PLUGIN_ID = 'UploadsTrayStatusBar';

interface Props {
  readonly uppy: Uppy;
}

// One of these is mounted per live instance in the tray's popover. Each instance needs its
// own DOM target, hence its own effect/state pair - extracted from UploadsTray so that loop
// doesn't call hooks a variable number of times in a single component.
export const UploadsTrayInstanceStatusBar = ({ uppy }: Readonly<Props>) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!container) {
      return undefined;
    }

    uppy.use(StatusBarPlugin, {
      id: STATUS_BAR_PLUGIN_ID,
      target: container,
      hideAfterFinish: false,
      hideUploadButton: true,
    });

    return () => {
      const plugin = uppy.getPlugin(STATUS_BAR_PLUGIN_ID);
      if (plugin) {
        uppy.removePlugin(plugin);
      }
    };
  }, [uppy, container]);

  return <Box ref={setContainer} />;
};
